module.exports = __webpack_public_path__ + "static/media/25.89508f53.jpg";